"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _useDefault3 = require("../_utils/hooks/useDefault");
var _forwardRefWithStatics = require("../_utils/forward-ref-with-statics");
var _MenuGroup = require("./MenuGroup");
var _SubMenu = require("./SubMenu");
var _MenuItem = require("./MenuItem");
var _MenuContext = require("./MenuContext");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["theme", "title", "tag", "icon", "back", "children", "className", "collapsable", "defaultCollapsed", "collapsed", "onCollapsedChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Menu = (0, _forwardRefWithStatics.forwardRefWithStatics)(function Menu(_ref, ref) {
  var _classNames2;
  var theme = _ref.theme,
    title = _ref.title,
    tag = _ref.tag,
    icon = _ref.icon,
    back = _ref.back,
    children = _ref.children,
    className = _ref.className,
    collapsable = _ref.collapsable,
    _ref$defaultCollapsed = _ref.defaultCollapsed,
    defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed,
    _ref$collapsed = _ref.collapsed,
    collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
    _ref$onCollapsedChang = _ref.onCollapsedChange,
    onCollapsedChange = _ref$onCollapsedChang === void 0 ? function () {} : _ref$onCollapsedChang,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // const { classPrefix } = useConfig();
  var classPrefix = (0, _usePrefixCls.usePrefixCls)('menu');

  // eslint-disable-next-line no-param-reassign
  var _useDefault = (0, _useDefault3.useDefault)(collapsed, defaultCollapsed, onCollapsedChange);
  var _useDefault2 = (0, _slicedToArray2.default)(_useDefault, 2);
  collapsed = _useDefault2[0];
  onCollapsedChange = _useDefault2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    mobileCollapsed = _useState4[0],
    setMobileCollapsed = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!collapsed) {
      setHover(false);
    }
  }, [collapsed]);
  if (Array.isArray(icon)) {
    // eslint-disable-next-line
    icon = icon[0];
  }
  var renderBack = (0, _typeof2.default)(back) === "object" ? function () {
    var title = back.title,
      description = back.description,
      _back$onClick = back.onClick,
      onClick = _back$onClick === void 0 ? function () {
        return null;
      } : _back$onClick;
    var titleList = /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(classPrefix, "-menu__title-list")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("".concat(classPrefix, "-h2"), (0, _defineProperty2.default)({}, "".concat(classPrefix, "-menu__title-main"), !!description))
    }, title), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(classPrefix, "-menu__title-text")
    }, description));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(classPrefix, "-menu__title-back")
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "".concat(classPrefix, "-menu__back"),
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "btnback"
    })), titleList);
  } : function () {
    return null;
  };
  return /*#__PURE__*/_react.default.createElement(_MenuContext.MenuContext.Provider, {
    value: {
      collapsed: collapsed && !hover,
      setMobileCollapsed: setMobileCollapsed
    }
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref,
    className: (0, _classnames.default)("".concat(classPrefix, "-menu"), className, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, "".concat(classPrefix, "-menu--light"), theme !== "dark"), (0, _defineProperty2.default)(_classNames2, "".concat(classPrefix, "-menu-is-locked"), collapsed), (0, _defineProperty2.default)(_classNames2, "".concat(classPrefix, "-menu-is-collapsed"), collapsed && !hover), (0, _defineProperty2.default)(_classNames2, "".concat(classPrefix, "-menu-mobile-collapsed"), mobileCollapsed), _classNames2))
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__header"),
    onMouseEnter: function onMouseEnter() {
      return collapsed && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return collapsed && setHover(false);
    },
    onClick: function onClick() {
      return setMobileCollapsed(function (collapsed) {
        return !collapsed;
      });
    }
  }, !!title && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__title")
  }, !!icon && (typeof icon === "string" ? /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(classPrefix, "-menu__title-icon"),
    src: icon,
    alt: "icon"
  }) : icon), /*#__PURE__*/_react.default.createElement("h2", {
    className: "".concat(classPrefix, "-h2")
  }, title), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "arrowdown"
  })), renderBack()), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__body"),
    onMouseEnter: function onMouseEnter() {
      return collapsed && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return collapsed && setHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(classPrefix, "-menu__list")
  }, children)), !!collapsable && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__footer")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__fold"),
    onClick: function onClick() {
      return onCollapsedChange(!collapsed);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classPrefix, "-menu__fold-icon")
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "fold"
  }))))));
}, {
  Group: _MenuGroup.MenuGroup,
  SubMenu: _SubMenu.SubMenu,
  Item: _MenuItem.MenuItem
});

// Menu.displayName = "Menu";
var _default = exports.default = Menu; // export { MenuGroupProps } from "./MenuGroup";
// export { MenuItemProps } from "./MenuItem";
// export { SubMenuProps } from "./SubMenu";